import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "flex justify-center" };
const _hoisted_2 = { class: "w-[900px]" };
import _ from "lodash";
import BlockEditor from "@/components/uikit/platformComponents/blockEditor/BlockEditor.vue";
import BlockViewer from "@/components/uikit/platformComponents/blockEditor/BlockViewer.vue";
import UConfirmDialog from "@/components/uikit/uComponents/UConfirmDialog.vue";
import { computed, onMounted, onUnmounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { useUser } from "@/composables/useAuth";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ItParkEditPage',
    setup(__props) {
        const isEditMode = ref(true);
        const blocks = ref([]);
        const parkName = ref("");
        // Новый флаг: данные готовы к отображению
        const isDataReady = ref(false);
        const store = useStore();
        const user = useUser();
        const router = useRouter();
        const toast = useToast();
        onMounted(async () => {
            const itParkId = router.currentRoute.value.params.id;
            if (itParkId) {
                try {
                    await store.dispatch("itPark/getItPark", itParkId);
                    const itPark = store.getters["itPark/itPark"];
                    parkName.value = itPark.name;
                    blocks.value = itPark.description ? JSON.parse(itPark.description) : [];
                }
                catch (e) {
                    console.error("Error loading park", e);
                }
                finally {
                    isDataReady.value = true;
                }
            }
            else {
                isDataReady.value = true;
            }
        });
        onUnmounted(() => {
            store.dispatch("itPark/clearItPark");
        });
        const itPark = computed(() => store.getters["itPark/itPark"]);
        const publishDialog = ref();
        const openPublishDialog = () => {
            publishDialog.value?.openConfirmDialog();
        };
        async function publishItPark() {
            await saveItPark();
            await store.dispatch("itPark/publishItPark", itPark.value.id);
            toast.success("IT-Park published successfully");
        }
        const saveDialog = ref();
        const openSaveDialog = () => {
            saveDialog.value?.openConfirmDialog();
        };
        async function saveItPark() {
            const newParkRequest = {
                name: parkName.value,
                owner: `/api/users/${user?.id}`,
                address: "",
                description: JSON.stringify(blocks.value)
            };
            if (itPark.value) {
                if (itPark.value.parent) {
                    newParkRequest.id = _.split(itPark.value.parent, "/")[3];
                }
                else {
                    newParkRequest.id = itPark.value.id;
                }
            }
            const newPark = (await store.dispatch("itPark/uploadItPark", newParkRequest));
            toast.success("IT-Park saved successfully");
            if (!itPark.value) {
                router.push({ path: "/it-park-edit/" + newPark.id });
            }
        }
        const dataLoading = computed(() => store.getters["itPark/dataLoading"]);
        const breadcrumbItems = computed(() => [
            { label: "Dashborad", route: "/" },
            { label: "IT-Parks", route: "/it-parks" },
            { label: parkName.value }
        ]);
        return (_ctx, _cache) => {
            const _component_UBreadcrumbs = _resolveComponent("UBreadcrumbs");
            const _component_UProgressBar = _resolveComponent("UProgressBar");
            const _component_UButton = _resolveComponent("UButton");
            const _component_UInput = _resolveComponent("UInput");
            const _component_UContent = _resolveComponent("UContent");
            const _component_UList = _resolveComponent("UList");
            return (_openBlock(), _createBlock(_component_UList, null, {
                default: _withCtx(() => [
                    _createVNode(_component_UBreadcrumbs, { items: breadcrumbItems.value }, null, 8, ["items"]),
                    (dataLoading.value || !isDataReady.value)
                        ? (_openBlock(), _createBlock(_component_UProgressBar, {
                            key: 0,
                            green: "",
                            "is-loader": ""
                        }))
                        : (_openBlock(), _createBlock(_component_UContent, { key: 1 }, {
                            "header-left": _withCtx(() => [
                                (isEditMode.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(" Edit page ")
                                    ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(parkName.value), 1)
                                    ], 64))
                            ]),
                            "header-right": _withCtx(() => [
                                (itPark.value)
                                    ? (_openBlock(), _createBlock(_component_UButton, {
                                        key: 0,
                                        onClick: openPublishDialog
                                    }, {
                                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                                _createTextVNode(" Publish ", -1)
                                            ]))]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                _createVNode(_component_UButton, { onClick: openSaveDialog }, {
                                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                            _createTextVNode(" Save ", -1)
                                        ]))]),
                                    _: 1
                                }),
                                _createVNode(_component_UButton, {
                                    onClick: _cache[0] || (_cache[0] = ($event) => (isEditMode.value = !isEditMode.value))
                                }, {
                                    default: _withCtx(() => [
                                        (isEditMode.value)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode(" View ")
                                            ], 64))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createTextVNode(" Edit ")
                                            ], 64))
                                    ]),
                                    _: 1
                                })
                            ]),
                            default: _withCtx(() => [
                                (isEditMode.value)
                                    ? (_openBlock(), _createBlock(_component_UInput, {
                                        key: 0,
                                        modelValue: parkName.value,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((parkName).value = $event)),
                                        required: "",
                                        label: "IT-Park name",
                                        placeholder: "IT-Park name"
                                    }, null, 8, ["modelValue"]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_1, [
                                    _createElementVNode("div", _hoisted_2, [
                                        (isEditMode.value)
                                            ? (_openBlock(), _createBlock(BlockEditor, {
                                                key: 0,
                                                blocks: blocks.value,
                                                onUpdate: _cache[2] || (_cache[2] = (v) => (blocks.value = v))
                                            }, null, 8, ["blocks"]))
                                            : (_openBlock(), _createBlock(BlockViewer, {
                                                key: 1,
                                                blocks: blocks.value
                                            }, null, 8, ["blocks"]))
                                    ])
                                ])
                            ]),
                            _: 1
                        })),
                    _createVNode(UConfirmDialog, {
                        ref_key: "publishDialog",
                        ref: publishDialog,
                        label: "Are you sure you want to publish IT Park?\nThis action cannot be undone.",
                        "accept-label": "Yes",
                        "reject-label": "No",
                        onAccept: publishItPark
                    }, null, 512),
                    _createVNode(UConfirmDialog, {
                        ref_key: "saveDialog",
                        ref: saveDialog,
                        label: "Are you sure you want to save IT Park?\nThis action cannot be undone.",
                        "accept-label": "Yes",
                        "reject-label": "No",
                        onAccept: saveItPark
                    }, null, 512)
                ]),
                _: 1
            }));
        };
    }
});
